import React, { useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import NeuroViewModal from "../../../modals/admin/survey/NeuroViewModal";

const AddSurvey = () => {
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [surveys, setSurveys] = useState([
        {
            surveyName: "Cognitive Assessment",
            audience: "John Smith",
            campus: "Main Campus",
            cls: "Grade 5",
            section: "A",
            surveyReport: "Completed"
        },
        {
            surveyName: "Memory Test",
            audience: "Sarah Johnson",
            campus: "North Campus",
            cls: "Grade 3",
            section: "B",
            surveyReport: "Pending"
        },
        {
            surveyName: "Attention Assessment",
            audience: "Tom Brown",
            campus: "South Campus",
            cls: "Grade 4",
            section: "C",
            surveyReport: "In Progress"
        }
    ]);

    const handleDelete = (index) => {
        setSurveys(surveys.filter((_, i) => i !== index));
    };

    const handleAddQuestion = (survey) => {
        setIsQuestionModalOpen(true);
    };

    return (
        <>
            <div className="flex w-full items-center justify-between mt-4 space-x-2">
                <input
                    type="text"
                    placeholder="Search..."
                    className="border border-gray-300 rounded p-2 w-full"
                />
            </div>

            <div className="overflow-x-auto mt-6">
                <table className="table-auto w-full mt-6">
                    <thead className="py-4 border-b font-bold">
                        <tr className="bg-gray-100 border-b">
                            <th className="p-3">Survey Name</th>
                            <th className="p-3">Audience</th>
                            <th className="p-3">Campus</th>
                            <th className="p-3">Class</th>
                            <th className="p-3">Section</th>
                            <th className="p-3">Survey Report</th>
                            <th className="p-3"> Details </th>
                            <th className="p-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {surveys.map((survey, index) => (
                            <React.Fragment key={index}>
                                <tr className="hover:bg-gray-200">
                                    <td>{survey.surveyName}</td>
                                    <td>{survey.audience}</td>
                                    <td>{survey.campus}</td>
                                    <td>{survey.cls}</td>
                                    <td>{survey.section}</td>
                                    <td>{survey.surveyReport}</td>
                                    <td>
                                        <button
                                            className="bg-[#241763] text-white px-3 py-1 rounded hover:bg-[#241763]/80"
                                            onClick={() => handleAddQuestion(survey)}
                                        >
                                            Details 
                                        </button>
                                    </td>
                                    <td className="space-x-2 flex items-center py-2">
                                        <button
                                            className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                                        </button>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>

            {isQuestionModalOpen && (
                <NeuroViewModal
                    isOpen={isQuestionModalOpen}
                    onClose={() => setIsQuestionModalOpen(false)}
                />
            )}
        </>
    );
};

export default AddSurvey;